import React from 'react';

export type BookType = 'tafsir' | 'prophets' | 'bukhari' | 'muslim';

interface BookBadgeProps {
  book: BookType | string | null | undefined;
  size?: 'sm' | 'md';
  className?: string;
}

const BOOK_META: Record<BookType, { label: string; className: string }> = {
  tafsir: { label: 'Tafsir of Quran', className: 'book-badge-tafsir' },
  prophets: { label: 'Stories of Prophets', className: 'book-badge-prophets' },
  bukhari: { label: 'Sahih Bukhari', className: 'book-badge-bukhari' },
  muslim: { label: 'Sahih Muslim', className: 'book-badge-muslim' },
};

const FALLBACK_META = { label: 'Islamic Texts', className: 'book-badge-tafsir' };

export default function BookBadge({ book, size = 'sm', className = '' }: BookBadgeProps) {
  // Guard: undefined, null, empty string → show fallback badge
  if (!book) {
    return (
      <span
        className={`inline-flex items-center font-semibold rounded-full ${
          size === 'sm' ? 'text-[10px] px-2 py-0.5' : 'text-xs px-3 py-1'
        } ${FALLBACK_META.className} ${className}`}
      >
        {FALLBACK_META.label}
      </span>
    );
  }

  const meta = BOOK_META[book as BookType] ?? FALLBACK_META;

  return (
    <span
      className={`inline-flex items-center font-semibold rounded-full ${
        size === 'sm' ? 'text-[10px] px-2 py-0.5' : 'text-xs px-3 py-1'
      } ${meta.className} ${className}`}
    >
      {meta.label}
    </span>
  );
}

export { BOOK_META };